module.exports = __webpack_public_path__ + "img/GRCLogoOnly_Purple_Transparent.189c9c4d.png";